export interface IPropertyOwner {
    fullNameRaw: string;
}

export class PropertyOwner implements IPropertyOwner {
    public fullNameRaw: string;
}